import PropTypes from 'prop-types'
import Button from './Button' 
import DropDownButton from './DropDownButton' 

const Header = ({ idCenario, title, onStart, start, onMudarCenario, onMudarDistancias, onMudarAlgoritmo }) => {

    return (
        <div id ={'header'}>
        <header className='header'>
            <h1>{title}</h1>
            <Button
                idCenario={idCenario}
                text={start ? 'Clear' : 'Start'}
                onClick={onStart}
            />
            <DropDownButton
                idCenario={idCenario}
                text='Choose Algorithm' 
                onClick={onMudarAlgoritmo}
            />
            <Button
                idCenario={idCenario}
                text='Change Scenery' 
                onClick={onMudarCenario}
            />
            <Button
                idCenario={idCenario}
                text='Change Distances' 
                onClick={onMudarDistancias}
            />
        </header>
        </div>
    )
}

Header.defaultProps = {
    title: 'Algorithm Race',
}

Header.propTypes = {
    title: PropTypes.string.isRequired,
}

export default Header